const NAME = "FEED";

export const PRIVACY_NAMES = {
    'P': "private",
    'U': "public",
    'L': "custom",
    'G': "group",
    'T': "taskTeam",
}

export default NAME;
